import React, {useContext, useState} from 'react';
import * as R from 'ramda';
import {
  Card,
  CardBody,
  Row,
  Col,
  Badge,
  Nav,
  NavLink,
  NavItem,
  TabContent,
  TabPane,
} from 'reactstrap';

import Overall from '@/internal/pages/Revenue/Payout/Overall';
import Particular from '@/internal/pages/Revenue/Payout/Particular';
import {blank, numberFormat} from '@/util';
import '@/internal/pages/Revenue/Payout/index.css';
import useAPI from '@/hooks/useAPI';
import {payoutRecord} from '@/internal/apis/index';
import {RevenueCtx} from '@/contexts';

const PayOut = () => {
  const data = useContext(RevenueCtx);
  const revenueId = R.pathOr({}, ['revenueId'], data);
  const payMode = R.pathOr({}, ['payMode'], data);

  const initData = {
    activeTab: 'overall',
    currentPayMode: payMode,
    page: 0,
  };
  const [currentData, setData] = useState(initData);
  const {activeTab, currentPayMode, page} = currentData;

  const {result: {data: payoutData} = {}} = useAPI(payoutRecord, {
    args: [revenueId, currentPayMode, page],
  });

  const toggle = tab => {
    if (activeTab !== tab)
      setData({
        ...initData,
        activeTab: tab,
      });
  };

  if (blank(payoutData)) {
    return null;
  }

  return (
    <>
      <b md={10}>Payout Details</b>
      <div className='float-right'>
        <Badge color='danger'>Fully Settled</Badge>&nbsp;
        <Badge color='success'>Not Yet Fully Settled</Badge>
      </div>
      <Card>
        <CardBody>
          <Row>
            <Col md={3}>
              <strong>Total Installment No.</strong>
            </Col>
            <Col md={3} className='text-right'>
              <strong>Total Entitled Payout Amount</strong>
            </Col>
            <Col md={3} className='text-right'>
              <strong>Total Settled Payout Amount</strong>
            </Col>
            <Col md={3} className='text-right'>
              <strong>Total Outstanding Payout Amount</strong>
            </Col>
          </Row>
          <Row>
            <Col md={3}>{payoutData.totalInstallmentNo}</Col>
            <Col className='text-right' md={3}>
              {numberFormat.toDollar(payoutData.totalEntitledPayoutAmount)}
            </Col>
            <Col className='text-right' md={3}>
              {numberFormat.toDollar(payoutData.totalSettledPayoutAmount)}
            </Col>
            <Col className='text-right' md={3}>
              {numberFormat.toDollar(payoutData.totalOutstandingPayoutAmount)}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <br />
      <Nav tabs>
        <NavItem>
          <NavLink
            className={activeTab === 'overall' ? 'active' : ''}
            onClick={() => {
              toggle('overall');
            }}
          >
            Overall
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === 'particular' ? 'active' : ''}
            onClick={() => {
              toggle('particular');
            }}
          >
            Particular
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId='overall'>
          <Overall result={payoutData} />
        </TabPane>
        <TabPane tabId='particular'>
          <Particular
            result={payoutData}
            totalSize={payoutData.totalSize}
            currentData={currentData}
            setData={setData}
          />
        </TabPane>
      </TabContent>
    </>
  );
};

export default PayOut;
